import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Img from "gatsby-image"

import media from "../../styles/media"

const ContentSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.black};
  margin-bottom: 30px;

  ${media.tablet`
    flex-direction: ${props =>
      props.alignment === "left" ? "row" : "row-reverse"};
    margin: 0;
  `}
`

const ContentBlock = styled.div`
  text-align: left;

  h1,
  h2 {
    display: inline;
    font-size: 20px;
    line-height: 24px;
    margin: 0;

    ${media.tablet`
      font-size: 45px;
      line-height: 54px;
    `}
  }

  h1 {
    font-family: StanleyRegular, serif;
    font-style: italic;
    font-weight: normal;
  }

  h2 {
    font-family: StanleyBold, serif;
    a {
      text-decoration: none;
      color: ${props => props.theme.black};

      &:hover {
        color: ${props => props.theme.red};
      }
    }
  }

  ${media.tablet`
    align-self: center;
    width: 100%;
  `};
`

const Content = styled.div`
  padding: 0 20px;

  ${media.tablet`
;
    padding: 0 40px;
  `}
`

const ImageSectionBlock = styled.div`
  width: 100%;
  margin-bottom: 12px;

  img {
    height: 100%;
    width: 100%;
    vertical-align: bottom;
  }

  ${media.tablet`
    margin: 0;
  `}
`

export const ContentSectionBlock = ({
  captionTitle,
  captionText,
  fluid,
  alignment,
  textLinkUrl,
}) => {
  return (
    <ContentSectionContainer alignment={alignment}>
      <ImageSectionBlock>
        <Img alt={captionTitle} fluid={fluid} />
      </ImageSectionBlock>
      <ContentBlock>
        <Content>
          <h1>{captionTitle} </h1>
          <h2>
            <a href={textLinkUrl}>{captionText}</a>
          </h2>
        </Content>
      </ContentBlock>
    </ContentSectionContainer>
  )
}

ContentSectionBlock.propTypes = {
  captionTitle: PropTypes.string,
  captionText: PropTypes.string,
  textLinkUrl: PropTypes.string,
  fluid: PropTypes.object,
  alignment: PropTypes.oneOf(["left", "right"]),
}
